import React from 'react';

import PropTypes from 'prop-types';

import MarketingCards from '~/acquisition/components/MarketingCards';
import { gridColumnsSettingsType } from '~/grid/utils/addNewGridColumnSettings';
import useGender from '~/shared/utils/useGender';

const BuilderMarketingCards = ({ container, ...rest }) => {
  const { gender } = useGender();
  return (
    container && (
      <MarketingCards
        container={container}
        gender={gender}
        {...rest}
        data-builder-component-type="marketing_cards"
      />
    )
  );
};

BuilderMarketingCards.propTypes = {
  cardVariant: PropTypes.string,
  container: PropTypes.string,
  gridColumnsSettings: gridColumnsSettingsType,
  hideNavigationMobile: PropTypes.bool,
  isCarousel: PropTypes.shape({
    desktop: PropTypes.bool,
    mobile: PropTypes.bool,
  }),
  mobileCardLayout: PropTypes.string,
  mobileContainer: PropTypes.string,
};

export default BuilderMarketingCards;
